<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div style="position:relative;">
          <h2><a href="/trials"><i class="fa fa-angle-double-left"></i></a>Test Details</h2>
          <template v-if="isAdmin">
            <button type="button" class="btn btn-sm btn-warning"
              @click="archiveTrial(trial)"
              v-if="! trial.archived_at"
              style="position: absolute;right: 0;top: 0;"
            >
              Archive <i class="fa fa-archive"></i>
            </button>
            <button type="button" class="btn btn-sm btn-warning"
              @click="unArchiveTrial(trial)"
              v-if="trial.archived_at"
              style="position: absolute;right: 0;top: 0;"
            >
              Unarchive <i class="fa fa-undo-alt"></i>
            </button>
            <button type="button" class="btn btn-sm btn-danger"
              @click="rolloutTrial(trial)"
              v-if="! trial.rolled_out_at"
              style="position: absolute;right: 120px;top: 0;"
            >
              Roll Out <i class="fa fa-file-export"></i>
            </button>
            <button type="button" class="btn btn-sm btn-danger"
              @click="rollinTrial(trial)"
              v-if="trial.rolled_out_at"
              style="position: absolute;right: 120px;top: 0;"
            >
              Roll In
              <i class="fa fa-undo-alt"></i>
            </button>
          </template>
        </div>
        <p class="text-muted" v-if="trial.roll_out">Test rolled out at {{trial.created_at}}. <a :href="`/roll_outs/${trial.roll_out.id}`">Show Roll Out</a></p>
        <a :href="`/storage/${logoPath}`" v-if="logoPath" data-lity>
          <img :src="`/storage/${logoPath}`" style="max-height:250px;">
        </a>
        <div class="accordion" id="accordionShow">
          <step-part header="General">
            <create-step-1 :nav="false" stepType="trial"
              @update="update"
              :uploadUrl="`/trials/${this.trial.id}/logo`"
            />
          </step-part>
          <step-part header="Key Account">
            <create-step-2 :nav="false" stepType="trial"
              @update="update"
              :trial="trial"
            />
          </step-part>
          <step-part header="Equipment and Printers">
            <create-step-3 :nav="false" stepType="trial"
              @update="update"
            />
          </step-part>
          <step-part header="Products">
            <create-step-4 :nav="false" stepType="trial"
              @update="update"
              :trialId="trial.id"
            />
          </step-part>
          <step-part header="Communication">
            <create-step-5 :nav="false" stepType="trial" :canUploadImages="true"
              @update="update"
              @openDocumentUploadModal="openDocumentUploadModal"
            />
          </step-part>
          <step-part header="General Store Pictures">
            <general-store-pictures
              @openGeneralUploadModal="openGeneralUploadModal"
              @openGeneralFolderModal="openGeneralFolderModal"
            />
          </step-part>
          <step-part header="Promotion">
            <create-step-6 :nav="false" stepType="trial" :canUploadImages="true"
              @update="update"
              :trialPromos="trial.promos"
              :trialId="trial.id"
              @openDocumentUploadModal="openDocumentUploadModal2"
            />
          </step-part>
        </div>
      </div>
    </div>
    <document-upload-modal :url="documentUploadUrl" :documents="documents"
      @fileUploaded="addDocumentToCommunication"
    />
    <general-documents-upload-modal
      :url="generalDocumentsUploadUrl"
      @fileUploaded="addDocumentToTrial"
      :documents="documentsFolder ? documentsFolder.documents : []"
      :isForFolder="documentsFolder"
    />
    <general-documents-folder-modal
      :url="`/trials/${trial.id}/document_folders`"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: ['trial'],
    data() {
      return {
        isAdmin: window.isAdmin,
        documentUploadUrl: '/',
        documents: [],
        documentsFolder: null,
        printerMap: {
          kiosk: {
            new: {
              'p_4_n_305_6r': '305 Printer 6R',
              'p_4_n_305_5r': '305 Printer 5R',
              'p_4_n_6900_6r': '6900 new 6R',
              'p_4_n_6900_5r': '6900 new 5R',
            },
            ref: {
              'p_4_r_6800_6r': '6800 ref 6R',
              'p_4_r_6850_6r': '6850 ref 6R',
            },
          },
          apex: {
            new: {
              'p_4_n_7000_new_6r': '7000 NEW 6R',
              'p_4_n_7000_new_5r': '7000 NEW 5R',
            },
            ref: {
              'p_4_r_7000_ref': '7000 ref',
              'p_4_r_7015_ref': '7015 ref',
            },
          },
          standalone: {
            new: {
              'p_4_n_305_6r': '305 Printer 6R',
              'p_4_n_305_5r': '305 Printer 5R',
              'p_4_n_6900_new_6r': '6900 new 6R',
              'p_4_n_6900_new_5r': '6900 new 5R',
              'p_4_n_7000_new_6r': '7000 NEW 6R',
              'p_4_n_7000_new_5r': '7000 NEW 5R',
            },
            ref: {
              'p_4_r_7000_ref': '7000 ref',
              'p_4_r_7015_ref': '7015 ref',
              'p_4_r_6800_ref': '6800 ref',
              'p_4_r_6850_ref': '6850 ref',
            },
          },
          large: {
            new: {
              'p_8_n_88xx': '88xx NEW',
              'p_8_n_d4600': 'D4600 NEW',
            },
            ref: {
              'p_8_r_8800': '8800 ref',
              'p_8_r_8810': '8810 ref',
              'p_8_r_d4000': 'D4000 ref',
            },
          },
        }
      }
    },
    computed: {
      ...mapState(['logoPath']),
      generalDocumentsUploadUrl() {
        return this.documentsFolder ?
          `/trials/${this.trial.id}/general_documents?folder=${this.documentsFolder.id}` :
          `/trials/${this.trial.id}/general_documents`
      }
    },
    methods: {
      addDocumentToCommunication(document) {
        this.documents.push(document)
      },
      update() {
        axios.put(`/trials/${this.trial.id}`, this.$store.getters.postData).then(({data}) => {
          window.notification.success(`Test has been updated`, 'Success!')
          window.removeEventListener('beforeunload', this.preventClose)
        })
      },
      openDocumentUploadModal(payload) {
        this.documentUploadUrl = `/trials/${this.trial.id}/${payload.type}/${payload.communication.id}/documents`
        let existingCom = null;
        if (payload.type === 'pos_communications') {
          existingCom = this.$store.getters.existingPosCommunication(payload.communication)
        } else if (payload.type === 'social_media_communications') {
          existingCom = this.$store.getters.existingSmCommunication(payload.communication)
        } else {
          existingCom = this.$store.getters.existingKaCommunication(payload.communication)
        }
        if (! existingCom) {
          existingCom = {
            id: payload.communication.id,
            documents: []
          }
          if (payload.type === 'pos_communications') {
            this.$store.commit('addTrialPosCommunications', existingCom)
          } else if (payload.type === 'social_media_communications') {
            this.$store.commit('addTrialSmCommunications', existingCom)
          } else {
            this.$store.commit('addTrialKaCommunications', existingCom)
          }
        }
        this.documents = existingCom.documents
        $('#documentsUploadModal').modal('show')
      },
      openDocumentUploadModal2(promo) {
        this.documentUploadUrl = `/trials/${this.trial.id}/promos/${promo.id}/documents`
        let existingPromo = this.$store.getters.existingPromo(promo)
        if (! existingPromo) {
          existingPromo = {
            id: promo.id,
            documents: [],
            pivot: {
              description: ''
            }
          }
          this.$store.commit('addTrialPromo', existingPromo)
        }
        this.documents = existingPromo.documents
        $('#documentsUploadModal').modal('show')
      },
      preventClose(e) {
        e.preventDefault()
        e.returnValue = ''
      },
      archiveTrial(trial) {
        if (window.confirm(`Do you really want to archive this test?`)) {
          window.axios.put(`/trials/${trial.id}/archive`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      rolloutTrial(trial) {
        if (window.confirm(`Do you really want to roll out this test?`)) {
          window.axios.put(`/trials/${trial.id}/rollout`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      rollinTrial(trial) {
        if (window.confirm(`Do you really want to roll in this test?`)) {
          window.axios.put(`/trials/${trial.id}/rollin`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      unArchiveTrial(trial) {
        if (window.confirm(`Do you really want to unarchive this test?`)) {
          window.axios.put(`/trials/${trial.id}/unarchive`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      openGeneralUploadModal(folder = null) {
        this.documentsFolder = folder
        this.$nextTick(() => $('#generalDocumentsUploadModal').modal('show'))
      },
      openGeneralFolderModal() {
        $('#generalDocumentsFolderModal').modal('show')
      },
      addDocumentToTrial(doc) {
        if (this.documentsFolder) {
          this.documentsFolder.documents.push(doc)
        } else {
          this.$store.commit('addGeneralDocument', doc)
        }
      },
    },
    created() {
      this.$store.commit('changeSelectedUser', this.trial.user)
      this.$store.commit('changeSelectedCountry', this.trial.country)
      this.$store.commit('changeSelectedDistributor', this.trial.distributor)
      this.$store.commit('changeStartDate', this.trial.start_date)
      this.$store.commit('changeTestPeriod', this.trial.test_period)
      this.$store.commit('changeLogoPath', this.trial.logo_path)

      this.$store.commit('changeName', this.trial.key_account.name)
      this.$store.commit('changeType', this.trial.key_account.type)
      this.$store.commit('changeSalesName', this.trial.key_account.sales_name)
      this.$store.commit('changeSalesPhone', this.trial.key_account.sales_phone_number)
      this.$store.commit('changeSalesEmail', this.trial.key_account.sales_email)
      this.$store.commit('changeMarketingName', this.trial.key_account.marketing_name)
      this.$store.commit('changeMarketingPhone', this.trial.key_account.marketing_phone_number)
      this.$store.commit('changeMarketingEmail', this.trial.key_account.marketing_email)
      this.$store.commit('changeStoresNumber', this.trial.key_account.stores)
      this.$store.commit('changeStoresPotentialRollouts', this.trial.key_account.potential_rollouts)
      this.$store.commit('changeStoresDescription', this.trial.key_account.stores_description)

      const equipments = []

      if (this.trial.kiosk_equipment) {
        this.$store.commit('changeEquipment', 'kiosk')
        equipments.push({
          type: 'kiosk',
          equipment: this.trial.kiosk_equipment,
        })
      }

      if (this.trial.apex_equipment) {
        this.$store.commit('changeEquipment', 'apex')
        equipments.push({
          type: 'apex',
          equipment: this.trial.apex_equipment,
        })
      }

      if (this.trial.standalone_equipment) {
        this.$store.commit('changeEquipment', 'standalone')
        equipments.push({
          type: 'standalone',
          equipment: this.trial.standalone_equipment,
        })
      }

      equipments.forEach(equipmentUnit => {
        const equipment = equipmentUnit.equipment
        const equipmentType = equipmentUnit.type

        if (equipment.printers_4_new) {
          this.$store.commit('changeSmallPrinters', { key: equipmentType, value:'new' })
          Object.keys(this.printerMap[equipmentType].new).forEach(printerKey => {
            const printer = this.printerMap[equipmentType].new[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeSmallPrintersNew', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_4_refurbished) {
          this.$store.commit('changeSmallPrinters', { key: equipmentType, value:'refurbished' })
          Object.keys(this.printerMap[equipmentType].ref).forEach(printerKey => {
            const printer = this.printerMap[equipmentType].ref[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeSmallPrintersRefurbished', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_8_new) {
          this.$store.commit('changeLargePrinters', { key: equipmentType, value:'new' })
          Object.keys(this.printerMap.large.new).forEach(printerKey => {
            const printer = this.printerMap.large.new[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeLargePrintersNew', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_8_refurbished) {
          this.$store.commit('changeLargePrinters', { key: equipmentType, value:'refurbished' })
          Object.keys(this.printerMap.large.ref).forEach(printerKey => {
            const printer = this.printerMap.large.ref[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeLargePrintersRefurbished', { key: equipmentType, printer, value })
          })
        }

        if (equipmentType === 'apex') {
          this.$store.commit('changeApexHeadunitsNew', equipment.headunits_new)
          this.$store.commit('changeApexHeadunitsRefurbished', equipment.headunits_refurbished)
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 30', value: equipment.cabinet_apex_30 })
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 40', value: equipment.cabinet_apex_40 })
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 70', value: equipment.cabinet_apex_70 })
        } else if (equipmentType === 'kiosk') {
          if (equipment.headunits_new) {
            this.$store.commit('changeKioskHeadunits', 'new')
            this.$store.commit('changeKioskHeadunitsNew', { headunit: 'G20', value: equipment.h_n_g20 })
            this.$store.commit('changeKioskHeadunitsNew', { headunit: 'Janus', value: equipment.h_n_janus })
          }
          if (equipment.headunits_refurbished) {
            this.$store.commit('changeKioskHeadunits', 'refurbished')
            this.$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 1 ref', value: equipment.h_r_g4xl_1_ref })
            this.$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 2 ref', value: equipment.h_r_g4xl_2_ref })
          }
          if (equipment.cabinets_new) {
            this.$store.commit('changeKioskCabinets', 'new')
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 17', value: equipment.cabinet_skipper_17 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 24', value: equipment.cabinet_skipper_24 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Transformer 24', value: equipment.cabinet_tranformer_24 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: '6900 Cabinet 17', value: equipment.cabinet_6900_cabinet_17 })
          }
          if (equipment.cabinets_refurbished) {
            this.$store.commit('changeKioskCabinets', 'refurbished')
            this.$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 17', value: equipment.cabinet_transformer_ref_17 })
            this.$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 24', value: equipment.cabinet_transformer_ref_24 })
          }
        } else {
          if (equipment.connection_pc) this.$store.commit('changeConnection', 'pc')
          if (equipment.connection_mac) this.$store.commit('changeConnection', 'mac')
        }
      })

      this.$store.commit('changeStoresNumber2', this.trial.stores)
      this.$store.commit('changeSoftware', this.trial.software_version)
      this.$store.commit('changeRbm', this.trial.rbm_units)

      this.$store.commit('changeCurrency', this.trial.currency)
      this.$store.commit('changeOriginalCurrency', this.trial.original_currency)
      this.$store.commit('changeExchangesTo', this.trial.exchanges_to)

      this.$store.dispatch('fetchSmallProducts', this.trial.id).then(res => {
        this.trial.small_products.forEach(({pivot}) => this.$store.commit('change5RProducts', { product: pivot.small_product_id, value: pivot.price}))
      })
      this.$store.dispatch('fetchMiddleProducts', this.trial.id).then(res => {
        this.trial.middle_products.forEach(({pivot}) => this.$store.commit('change6RProducts', { product: pivot.middle_product_id, value: pivot.price}))
      })
      this.$store.dispatch('fetchLargeProducts', this.trial.id).then(res => {
        this.trial.large_products.forEach(({pivot}) => this.$store.commit('change8RProducts', { product: pivot.large_product_id, value: pivot.price}))
      })
      this.trial.creative_products.forEach(product => this.$store.commit('changeCreativeProducts', product.id))

      this.trial.pos_communications.forEach(communication => {
        this.$store.commit('changeCommunicationPOS', communication.id)
        this.$store.commit('addTrialPosCommunications', communication)
      })
      this.trial.social_media_communications.forEach(communication => {
        this.$store.commit('changeCommunicationSM', communication.id)
        this.$store.commit('addTrialSmCommunications', communication)
      })
      this.trial.key_account_communications.forEach(communication => {
        this.$store.commit('changeCommunicationKA', communication.id)
        this.$store.commit('addTrialKaCommunications', communication)
      })
      this.$store.commit('changeTargetgroup', this.trial.targetgroup)

      this.$store.commit('changeCompanyWebsite', this.trial.website)

      this.trial.promos.forEach(promo => {
        this.$store.commit('changePromoDuringTest', promo.id)
        this.$store.commit('addTrialPromo', promo)
      })

      if (this.trial.promo_general_moments) {
        this.$store.commit('changeBrandingGeneral', 'kodakmoments')
      }
      if (this.trial.promo_general_branding_co) {
        this.$store.commit('changeBrandingGeneral', 'co')
      }
      if (this.trial.promo_general_branding_company) {
        this.$store.commit('changeBrandingGeneral', 'company')
      }

      this.trial.general_documents.forEach(doc => this.$store.commit('addGeneralDocument', doc))

      this.trial.general_documents_folders.forEach(folder => this.$store.commit('addGeneralDocumentsFolder', folder))
      $(document).ready(() => {
        $(':input').on('change', () => {
          window.addEventListener('beforeunload', this.preventClose)
        })
      })
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/TrialShow.vue